export const ConfigurationValues = {
  Vat: 'FRXX123456789',
  ConsumerKey: '51EE2B7C-22DD-4F78-8955-F94C3ED94B93',
  RootElementId: 'configuratorWrapper',
  OverviewSummaryUrl: '/assets/WidgetsCarConfigurator/ShoppingCartOverview.html',
  ShoppingCartUrl: '/assets/WidgetsCarConfigurator/ShoppingCartOverview.html',
  UrlRouting: false,
  Country: 'FR',
  Language: 'fr',
  ShowPriceSpinner: false,
  DisplayGrossPrices: true,
  HideImages: true,
  HideFooter: true,
  ShowConfigurationComparison: true,
};
